module.exports = __webpack_public_path__ + "img/user03.34b765d7.jpg";